/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

const unixMillisecondsToDateTime = (unixTimeInMilliseconds: number, includeSeconds: boolean = false) => {
  return dateToLocaleString(new Date(unixTimeInMilliseconds), includeSeconds)
}

const getDateTime = (includeSeconds: boolean = false) => {
  return dateToLocaleString(new Date(), includeSeconds)
}

const dateToLocaleString = (date: Date, includeSeconds: boolean = false,includeTime: boolean = true) => {
  return date.toLocaleString([], getLocaleStringFormat(includeSeconds, includeTime))
}
const stringToDateToLocaleString =(dateStr: string, includeSeconds: boolean = false, includeTime: boolean = true)=> {
  return dateToLocaleString(new Date(dateStr), includeSeconds, includeTime)
}
const getLocaleStringFormat = (includeSeconds: boolean = false,includeTime: boolean = true): Intl.DateTimeFormatOptions => {
  return {
    dateStyle: 'short',
    timeStyle: includeTime ? !includeSeconds ? 'short' : 'medium' : undefined
  }
}

// function to get current unix time in milliseconds
const getCurrentUnixTimeInMilliseconds = () => {
  return new Date().getTime()
}


/**
 * TODO: We should not be storing numbers as strings. This function should be removed and the numbers should be stored as numbers.
 * Round a number to x decimals and return a string.
 * @param value - The number to round.
 * @param decimals - The number of decimals to round to.
 * @returns {any} - The rounded number as a string.
 */
const roundToXDecimals = (value: any, decimals: number): any => {
  if (value != null && !isNaN(value)) {
    value = value.toFixed(decimals);
    let strNum = value.toString();
    //let trimmedNum = parseFloat(strNum.replace(/0+$/, ''));
    return strNum
  }
  else {
    return value
  }
}

/**
 * Round a number to n decimals and return a float.
 * @param {number} num - The number to round.
 * @param {number} n - The number of decimals to round to.
 * @returns {number} - The rounded number.
 */
const roundToNDecimals = (num: number, n: number): number => {
  return parseFloat(num.toFixed(n));
}

const hasRequiredProps = (targetObj: any, requiredProps: Set<string>): boolean => {
  if (!targetObj || !requiredProps) {
    return false;
  }
  for (let prop of requiredProps) {
    if (!(prop in targetObj)) {
      return false;
    }
  }
  return true;
}

export {
  dateToLocaleString,
  stringToDateToLocaleString,
  unixMillisecondsToDateTime,
  getDateTime,
  getCurrentUnixTimeInMilliseconds,
  roundToXDecimals,
  roundToNDecimals,
  hasRequiredProps
}
